import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { COMPANY_STATUS_TRANSITION_TYPE } from '../../constants/enums/company.enum.constant'
import {
  CompanyDetailInterface,
  CompanyFormInterface
} from '../../interfaces/company'
import CompanyFormHandlerBtnBar from './CompanyFormHandlerBtnBar'
import CompanyFormMainBody from './CompanyFormMainBody'

const CompanyForm = ({
  companyDetail,
  formHandlers,
  disableForm,
  newForm
}: {
  companyDetail: CompanyDetailInterface
  formHandlers: {
    createCompany: (company: CompanyFormInterface) => void
    updateCompany: (company: CompanyFormInterface) => void
    statusChangeHandlerGenerator: (
      action: keyof typeof COMPANY_STATUS_TRANSITION_TYPE
    ) => () => void
  }
  disableForm: boolean
  newForm: boolean
}) => {
  const methods = useForm<CompanyDetailInterface>({
    defaultValues: {
      ...companyDetail
    }
  })
  const { handleSubmit } = methods

  return (
    <FormProvider {...methods}>
      <form>
        <CompanyFormHandlerBtnBar
          saveHandler={handleSubmit(formHandlers.updateCompany)}
          createHandler={handleSubmit(formHandlers.createCompany)}
          statusChangeHandler={formHandlers.statusChangeHandlerGenerator}
          disableForm={disableForm}
          newForm={newForm}
          companyStatus={companyDetail?.status}
        />
        <CompanyFormMainBody
          companyDetail={companyDetail}
          disableForm={disableForm}
          newForm={newForm}
        />
      </form>
    </FormProvider>
  )
}

export default CompanyForm
